import { parseDate } from '@internationalized/date';
import { useMemo } from 'react';
import {
  DateField as AriaDateField,
  DateInput as AriaDateInput,
  DateSegment,
} from 'react-aria-components';
import { useController } from 'react-hook-form';
import { Label } from './label';

export function DateField({ name, label, className, ...props }) {
  const { field } = useController({ name });
  const defaultValue = useMemo(() => tryParseDate(field.value), [field.value]);
  return (
    <AriaDateField
      {...props}
      name={name}
      defaultValue={defaultValue}
      onChange={(date) => field.onChange(date?.toString() ?? '')}
      onBlur={() => field.onBlur()}
    >
      <Label>{label}</Label>
      <AriaDateInput
        className="block w-full mt-1.5 px-3 pt-2 pb-1 text-body-dark rounded-md border border-solid border-300 shadow-sm cursor-text disabled:cursor-default whitespace-nowrap overflow-x-auto [scrollbar-width:none] focus-within:ring-1 focus-within:border-primary ring-primary"
        type="date"
      >
        {(segment) => (
          <DateSegment
            segment={segment}
            className="inline-block px-1 text-base text-center cursor-text leading-snug disabled:cursor-default whitespace-nowrap overflow-x-auto [scrollbar-width:none] data-[type=day]:min-w-8 data-[type=year]:min-w-14 data-[type=month]:min-w-8 data-[focused=true]:bg-primary-500 data-[focused=true]:text-white data-[placeholder=true]:text-light-500 data-[placeholder=true]:data-[focused=true]:text-white focus-visible:outline-none"
          />
        )}
      </AriaDateInput>
    </AriaDateField>
  );
}

function tryParseDate(value) {
  try {
    return parseDate(value);
  } catch {
    return '';
  }
}
